import AssetLoader from '@/shared/utils/asset-loader';

const TRACKING_INIT_IMAGE_URL = '/static/scripts/trackdb/init.gif?deviceId=14d98fef-1744-4197-9c52-7b8d3ce3f967&version=V1&sessionId=pK2gykZwazChS6h1nXOHcXNLbfNBotwM&customerId=1&subscriberId=342735&terminal=PC&mimeType=DASH&productId=1969732&duration=7294&agent=Chrome&agentVersion=85.0.4321.0&os=Windows&osVersion=x86_64&maker=Google&rendererType=HTML5&playerVersion=1.5.0&platform=BROWSER&productType=MOVIE';
const TRACKING_EVENTS_IMAGE_URL = '/static/scripts/trackdb/events.gif?sessionId=pK2gykZwazChS6h1nXOHcXNLbfNBotwM&customerId=1&sessionDuration=116&events=1,0,0,0;4,0,0,2000;0,0,0,8000';
const TRACKING_SCRIPT_URL = '/static/scripts/trackdb/tdbc.min.js';

export default {
  namespaced: true,
  state: {
    iframeBlocked: false,
    scriptsBlocked: false,
  },
  getters: {
    blocked(state) {
      return state.iframeBlocked || state.scriptsBlocked;
    },
  },
  mutations: {
    SET_TRACKING_IFRAME_BLOCKED(state, value) {
      state.iframeBlocked = value;
    },
    SET_TRACKING_SCRIPTS_BLOCKED(state, value) {
      state.scriptsBlocked = value;
    },
  },
  actions: {
    check({ commit }) {
      const loader = new AssetLoader();

      loader.load([
        { id: 'trackdb-init', src: TRACKING_INIT_IMAGE_URL, type: 'image' },
        { id: 'trackdb-events', src: TRACKING_EVENTS_IMAGE_URL, type: 'image' },
        { id: 'trackdb-script', src: TRACKING_SCRIPT_URL },
      ]).then(() => {
        commit('SET_TRACKING_SCRIPTS_BLOCKED', false);
      }).catch(() => {
        commit('SET_TRACKING_SCRIPTS_BLOCKED', true);
      }).finally(() => {
        loader.unload([{ id: 'trackdb-init' }, { id: 'trackdb-events' }, { id: 'trackdb-script' }]);
      });
    },
  },
};
